import { useEffect, useState } from "react";
import _ from "lodash";
import { Box, Card, Stack, Typography } from "@common-ui/ui";
// import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { getAllAssets, getWorkItems } from "../../services";
import { StatusChip } from "../../pages/WorkEvents/StatusChip";
import checkTableImage from "../../utils/checkTableImage";

const AssetCards = (props) => {
  const [placesList, setPlacesList] = useState([]);
  const [nonPlacesList, setNonPlacesList] = useState([]);
  const [loading, setLoading] = useState(false);

  const getWorkEvent = async () => {
    try {
      const response = await getWorkItems(props?.eventId, props?.orgId);
      const { places, nonPlaces } = await getAllAssets(
        response,
        props?.orgId,
        props?.eventId
      );
      setPlacesList(places);
      setNonPlacesList(nonPlaces);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    setLoading(true);

    getWorkEvent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    // {
    //   flex: 1,
    //   field: "image_id",
    //   headerName: "Image",
    //   minWidth: 0,
    //   sortable: false,
    //   renderCell: (params) => {
    //     return (
    //       <InsertPhotoIcon
    //         sx={{
    //           height: "2.2em",
    //           width: "4.2em",
    //         }}
    //       />
    //     );
    //   },
    // },
    {
      flex: 1,
      field: "work_item",
      headerName: "Work Item",
      minWidth: 0,
      sortable: false,
      renderCell: (params) => {
        return params.value ? params.value : "---";
      },
    },
    {
      width: 100,
      field: "image_url",
      headerName: "",
      align: "center",
      sortable: false,
      renderCell: (params) => checkTableImage(params?.value),
    },
    {
      flex: 1,
      field: "id",
      headerName: "Asset ID",
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return params.value ? params.value : "---";
      },
    },
    {
      flex: 1,
      field: "name",
      headerName: "Asset Name",
      sortable: false,
      renderCell: (params) => {
        return params.value ? params.value : "---";
      },
    },
    {
      flex: 1,
      field: "make",
      headerName: "Make",
      sortable: false,
      renderCell: (params) => {
        return params.value ? params.value : "---";
      },
    },
    {
      flex: 1,
      field: "model",
      headerName: "Model",
      sortable: false,
      renderCell: (params) => {
        return params.value ? params.value : "---";
      },
    },
    {
      flex: 1,
      field: "serial_number",
      headerName: "Serial Number",
      sortable: false,
      renderCell: (params) => {
        return params.value ? params.value : "---";
      },
    },
    {
      flex: 1,
      field: "status",
      headerName: "Status",
      sortable: false,
      renderCell: (params) => {
        return <StatusChip status={params.value ? params.value : "DEFAULT"} />;
      },
    },
  ];

  return (
    <>
      <Box>
        {Object.keys(nonPlacesList).length > 0
          ? _.map(nonPlacesList, (nonPlace, index) => (
              <div key={nonPlace?.system_id}>
                <Card sx={{ mb: "24px" }}>
                  <Stack direction="row" sx={{ pb: 1 }}>
                    <Box
                      component="main"
                      sx={{
                        alignItems: "center",
                        display: "flex",
                        flexGrow: 1,
                        minHeight: "100%",
                        backgroundColor: "#FFFFFF",
                        ".MuiDataGrid-virtualScroller": {
                          marginTop: "40px !important",
                        },
                        ".MuiDataGrid-columnHeaderTitle": {
                          fontWeight: 700,
                        },
                      }}
                    >
                      {props.combined ? (
                        <DataGridPro
                          getRowId={(row) => row?.system_id}
                          sx={{
                            border: 0,
                            ".MuiDataGrid-columnSeparator": {
                              display: "none",
                            },
                            "&.MuiDataGrid-root": {
                              border: "none",
                            },
                            "& .MuiDataGrid-cell:focus-within": {
                              outline: "none !important",
                            },
                            ".MuiDataGrid-columnHeaders": {
                              backgroundColor: "#F8F8F8",
                              border: "1px solid #EBEBEB",
                              minHeight: "40px !important",
                              maxHeight: "40px !important",
                              lineHeight: "40px !important",
                            },
                            ".MuiDataGrid-virtualScroller": {
                              marginTop: "40px",
                            },
                          }}
                          rows={nonPlace || []}
                          density="comfortable"
                          columns={columns}
                          pagination
                          components={{ Toolbar: GridToolbar }}
                          disableSelectionOnClick
                          autoHeight={true}
                          disableColumnResize
                          disableColumnSelector
                          disableColumnReorder
                          disableColumnPinning
                          disableColumnFilter
                          disableDensitySelector
                          disableChildrenSorting
                          hideFooter={true}
                          disableColumnMenu
                        />
                      ) : (
                        <DataGridPro
                          getRowId={(row) => row?.system_id}
                          sx={{
                            border: 0,
                            ".MuiDataGrid-columnSeparator": {
                              display: "none",
                            },
                            "&.MuiDataGrid-root": {
                              border: "none",
                            },
                            "& .MuiDataGrid-cell:focus-within": {
                              outline: "none !important",
                            },
                            ".MuiDataGrid-columnHeaders": {
                              backgroundColor: "#F8F8F8",
                              border: "1px solid #EBEBEB",
                              minHeight: "40px !important",
                              maxHeight: "40px !important",
                              lineHeight: "40px !important",
                            },
                            ".MuiDataGrid-virtualScroller": {
                              marginTop: "40px",
                            },
                          }}
                          rows={nonPlace || []}
                          density="comfortable"
                          columns={columns}
                          pagination
                          components={{ Toolbar: GridToolbar }}
                          disableSelectionOnClick
                          autoHeight={true}
                          disableColumnResize
                          disableColumnSelector
                          disableColumnReorder
                          disableColumnPinning
                          disableColumnFilter
                          disableDensitySelector
                          disableChildrenSorting
                          hideFooter={true}
                          disableColumnMenu
                        />
                      )}
                    </Box>
                  </Stack>
                </Card>
              </div>
            ))
          : ""}
        {Object.keys(placesList).length > 0
          ? _.map(placesList, (place, index) => (
              <div key={index}>
                <Card sx={{ mb: "24px" }}>
                  <Stack direction="row">
                    <Typography sx={{ mt: 1, p: 2 }} variant="h4">
                      {index}
                    </Typography>
                  </Stack>
                  <Stack direction="row" sx={{ pb: 1 }}>
                    <Box
                      component="main"
                      sx={{
                        alignItems: "center",
                        display: "flex",
                        flexGrow: 1,
                        minHeight: "100%",
                        backgroundColor: "#FFFFFF",
                        ".MuiDataGrid-virtualScroller": {
                          marginTop: "40px !important",
                        },
                        ".MuiDataGrid-columnHeaderTitle": {
                          fontWeight: 700,
                        },
                      }}
                    >
                      <DataGridPro
                        getRowId={(row) => row?.system_id}
                        sx={{
                          border: 0,
                          ".MuiDataGrid-columnSeparator": {
                            display: "none",
                          },
                          "&.MuiDataGrid-root": {
                            border: "none",
                          },
                          "& .MuiDataGrid-cell:focus-within": {
                            outline: "none !important",
                          },
                          ".MuiDataGrid-columnHeaders": {
                            backgroundColor: "#F8F8F8",
                            border: "1px solid #EBEBEB",
                            minHeight: "40px !important",
                            maxHeight: "40px !important",
                            lineHeight: "40px !important",
                          },
                          ".MuiDataGrid-virtualScroller": {
                            marginTop: "40px",
                          },
                        }}
                        rows={place || []}
                        density="comfortable"
                        columns={columns}
                        pagination
                        components={{ Toolbar: GridToolbar }}
                        disableSelectionOnClick
                        autoHeight={true}
                        disableColumnResize
                        disableColumnSelector
                        disableColumnReorder
                        disableColumnPinning
                        disableColumnFilter
                        disableDensitySelector
                        disableChildrenSorting
                        hideFooter={true}
                        disableColumnMenu
                      />
                    </Box>
                  </Stack>
                </Card>
              </div>
            ))
          : ""}
      </Box>
      {loading ? "Loading..." : ""}
    </>
  );
};

export default AssetCards;
